<div class="a_d_inline_block" :class="options.class || ''" v-translate="{ html: options.text, extra: options.extra }"></div>